export const PROJECT_ID='647f0906b0c2d3930bef';
export const DATABASE_ID='647f9fd674c52f12a214';
export const COLLECTION_ID='647f9feb67059ebe6500';